import { render, staticRenderFns } from "./ed-subject-building-process-modal.component.vue?vue&type=template&id=6dbbb8d2&scoped=true&"
import script from "./ed-subject-building-process-modal.component.ts?vue&type=script&lang=ts&"
export * from "./ed-subject-building-process-modal.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-subject-building-process-modal.component.scss?vue&type=style&index=0&id=6dbbb8d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbbb8d2",
  null
  
)

export default component.exports